// frontend/src/components/GroupHeader.jsx

import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

export default function GroupHeader({
  _,
  session,
  effectiveGroupInfo,
  hasActiveFilters,
  activeFilters,
  FILTER_LABELS,
  handleClearFilters,
  toggleFilters,
  handleClose,
  handleReopen,
  isReadOnly,
  secondaryInfo = null,
  actions = null
}) {
  return (
    <div className="mb-4">
      <div className="flex flex-col md:flex-row md:items-center md:justify-between">
        <p className="
              text-xl md:text-[28px] font-bold leading-tight
              text-[#111418] dark:text-gray-100
            "
        >
          {_('Travel Group')}: {effectiveGroupInfo.group_name || _('Unnamed group')}
        </p>

        <div className="mt-2 md:mt-0">
          <p className="header-sub">
            {_('Access code')}:{' '}
            <span className="font-semibold">
              {session.hash}
            </span>
          </p>
          <p className="header-sub">
            {_('Responsible')}:{' '}
            <span className="font-semibold">
              {effectiveGroupInfo.owner_name || _('N/A')}
            </span>
          </p>
          {secondaryInfo}
        </div>
      </div>

      <div className="flex flex-wrap items-center mt-4 md:mt-2 gap-2">
        {hasActiveFilters && (
          <div className="flex flex-wrap items-center gap-2 text-sm text-[#60748a] dark:text-gray-300">
            <span className="font-medium">
              {_('Filters applied')}:
            </span>
            <div className="flex flex-wrap gap-2">
              {activeFilters.map(([k, v]) => (
                <span
                  key={k}
                  className="px-2 py-0.5 rounded-full border
                             bg-[#f0f2f5] text-[#111418]
                             dark:bg-gray-800 dark:text-gray-100
                             border-[#e5e7eb] dark:border-gray-700"
                  title={`${FILTER_LABELS[k]}: ${(v || '').trim()}`}
                >
                  {FILTER_LABELS[k]}: {(v || '').trim()}
                </span>
              ))}
            </div>
          </div>
        )}

        <div className="flex items-center gap-2 ml-auto">
          {actions || (
            <>
              {hasActiveFilters && (
                <button
                  type="button"
                  onClick={handleClearFilters}
                  className="button-secondary"
                >
                  {_('Clear')}
                </button>
              )}

              <button
                className="button-secondary icon-button"
                onClick={toggleFilters}
              >
                <FontAwesomeIcon icon="filter" />
              </button>

              {session.role === 'leader' && (
                <button
                  className="button-secondary icon-button"
                  onClick={async () => {
                    const API = process.env.REACT_APP_API_BASE;
                    const res = await fetch(`${API}/api/group/export`, {
                      method: 'GET',
                      headers: { 'x-access-hash': session.hash }
                    });

                    if (!res.ok) throw new Error();

                    const blob = await res.blob();
                    const url = window.URL.createObjectURL(blob);

                    const a = document.createElement('a');
                    a.href = url;
                    a.download = 'goval-entry.xlsx';
                    document.body.appendChild(a);
                    a.click();
                    a.remove();

                    window.URL.revokeObjectURL(url);
                  }}
                >
                  <FontAwesomeIcon icon="file-excel" />
                </button>
              )}

              {!isReadOnly && (
                <>
                  <button
                    className="button-secondary icon-button"
                    onClick={() => handleClose(effectiveGroupInfo)}
                  >
                    <FontAwesomeIcon icon="lock" />
                  </button>

                  <button
                    className="button-secondary icon-button"
                    onClick={() => handleReopen(effectiveGroupInfo)}
                  >
                    <FontAwesomeIcon icon="lock-open" />
                  </button>
                </>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  )
}